import { render, staticRenderFns } from "./TCPlayer.vue?vue&type=template&id=5de6a852&scoped=true"
import script from "./TCPlayer.vue?vue&type=script&lang=js"
export * from "./TCPlayer.vue?vue&type=script&lang=js"
import style0 from "./TCPlayer.vue?vue&type=style&index=0&id=5de6a852&prod&lang=less&scoped=true"
import style1 from "./TCPlayer.vue?vue&type=style&index=1&id=5de6a852&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de6a852",
  null
  
)

export default component.exports